import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Breadcrumb from 'component/Breadcrumb';
import { RootState } from 'model';
import { IMeetingOrderFn } from 'type/meeting';
import { getMeetingDetailsV2, resetConflictSchedules, updateMeeting } from 'model/meeting';
import { getPageFrom } from 'util/meeting';
import MeetingOrderForm from 'component/MeetingOrderForm';
import styles from './index.module.scss';
import container from 'lib/container';
import tracker from 'lib/tracker';
import compare from './compare';
import { IMeetingDetail, MeetingOptionType } from 'type/meetingDetail';
import qs from 'qs';

const Edit: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  // URL 参数
  const params: { id: string } = useParams();
  const query = qs.parse(location.search.slice(1));
  const editType = query.editType as MeetingOptionType;

  const [crumbItems, setCrumbItems] = useState<{ path?: string; label: string }[]>([]);
  const meetingDetailV2 = useSelector((state: RootState) => state.meeting.meetingDetailV2);
  const [meetingDetail, setMeetingDetail] = useState<IMeetingDetail>();
  const repeatMeetingNo = useRef<string>();
  const subTitle = editType === MeetingOptionType.AllMeeting ? '修改全部周期会议' : editType === MeetingOptionType.ThisMeeting ? '仅修改本次会议' : '';

  useEffect(() => {
    if (meetingDetailV2) {
      // 修改单次会议，需手动设置为非周期会议
      setMeetingDetail({
        ...meetingDetailV2,
        isRepeatMeeting: editType === MeetingOptionType.AllMeeting
      });
      repeatMeetingNo.current = meetingDetailV2.repeatMeetingNo;
    }
  }, [meetingDetailV2]);

  const onConfirm: IMeetingOrderFn = useCallback(
    (orderParams) => {
      compare(params.id, orderParams, meetingDetailV2, tracker);
      return new Promise((resolve) => {
        dispatch(
          updateMeeting({
            meetingId: params.id,
            type: editType,
            repeatMeetingNo: repeatMeetingNo.current,
            params: orderParams,
            onSuccess: () => {
              container.sdk?.editMeetingSuccess(params.id);
              resolve({ success: true });
            },
            onFail: (err: any) => {
              if (err?.response?.data?.code === 400403002) {
                const data = err?.response?.data?.data;
                resolve({ success: false, data: data });
              } else if (err?.response?.data?.code === 400406011) {
                resolve({ success: false, errMesaage: '预约人（部门）、会议主题、会议地点可能包含涉黄/涉暴/政治/敏感信息，请检查后重试' });
              } else {
                resolve({ success: false, data: null });
              }
            }
          })
        );
      });
    },
    [meetingDetail]
  );

  const onCancel = () => {
    container.sdk?.cancelEditMeeting(params.id);

    history.goBack();
  };

  useEffect(() => {
    if (!params.id) return;
    dispatch(getMeetingDetailsV2(params.id));
    setCrumbItems([getPageFrom(), { path: `/details/${params.id}${location.search}`, label: '会议详情' }, { label: '修改会议' }]);

    return () => {
      dispatch(resetConflictSchedules());
    };
  }, []);

  return (
    <>
      <Breadcrumb items={crumbItems} />
      <div className={styles.body}>
        <MeetingOrderForm
          title="修改会议"
          subTitle={subTitle}
          meetingDetail={meetingDetail}
          onConfirm={onConfirm}
          onCancel={onCancel}
          confirmText="确认修改"
          formType="edit"
        />
      </div>
    </>
  );
};

export default Edit;
